import Loadable from "react-loadable";
import LoadablePlaceholder from "./loadable-placeholder";
import React from "react";

export default Loadable({ // eslint-disable-line new-cap
  loader: () => {
    return import(/* webpackMode: "lazy-once" */`../../public/images/logos/${window.env.avatarPath}`)
      .then(
        ({default: path}) => {
          return function GameManagerAvatar() {
            return <img className="avatar avatar--is-tiny" src={path} />;
          };
        }
      );
  },
  loading: LoadablePlaceholder
});
